import React, { useState } from "react";
import {
  Backdrop,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import ReportIcon from "../../assets/icons/report.png";
import { CloseTwoTone } from "@mui/icons-material";
import Loader from "components/Loader";

const InappropriateContent = ({ termsOpen, handleTermsClose }) => {
  return (
    <Dialog
      open={termsOpen}
      onClose={handleTermsClose}
            className="condition-dialog-wrapper"
    >
      <Grid
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Grid>

        <DialogTitle sx={{ m: 0, p: 2,   fontSize: {
      xs: "1rem",     // mobile
      sm: "1.1rem",   // tablet
      md: "1.2rem"    // desktop
    },fontWeight:"500" }}>
          Terms and Conditions for Reporting Inappropriate Content
        </DialogTitle>
        </Grid>
        <Grid>

        <IconButton onClick={handleTermsClose}>
          <CloseTwoTone />
        </IconButton>
        </Grid>
      </Grid>
      <Divider />
    
    <DialogContent className="dialog-content">
  <Typography
    sx={{
      color: "var(--text-gray)",
      lineHeight: 1.7,
      fontSize: "0.95rem",
      mb: 2,
    }}
  >
    We truly appreciate your help in keeping the platform safe. Please
    follow these simple guidelines:
  </Typography>

  <Typography
    sx={{
      color: "var(--text-gray)",
      lineHeight: 1.7,
      fontSize: "0.85rem",
      mb: 2,
      display: "flex",
      alignItems: "center",
      gap: 1,
    }}
  >
    1. If you see content that seems inappropriate or fake, use the report
    icon on the product page.
    <img src={ReportIcon} style={{ width: "22px" }} />
  </Typography>

  <Typography
    sx={{
      color: "var(--text-gray)",
      lineHeight: 1.7,
      fontSize: "0.85rem",
      mb: 2,
    }}
  >
    2. The details of your report, including your email and the reported
    product information, will be accessible to the team handling the
    review. They will assess the report and take appropriate action if
    necessary.
  </Typography>

  <Typography
    sx={{
      color: "var(--text-gray)",
      lineHeight: 1.7,
      fontSize: "0.85rem",
      mb: 2,
    }}
  >
    3. False reports may lead to penalties, including account suspension.
  </Typography>

  <Typography
    sx={{
      color: "var(--text-gray)",
      lineHeight: 1.7,
      fontSize: "0.85rem",
    }}
  >
    Thank you for helping us keep the platform safe and reliable.
  </Typography>
</DialogContent>
      {/* <DialogActions> */}
        <DialogActions className="dialog-action">
      <Button size="small"onClick={handleTermsClose} variant="contained"
          // color="error"
          >
        Close
      </Button>
      </DialogActions>
      {/* </DialogActions> */}
    </Dialog>
  );
};

export default InappropriateContent;

// const FullScreenLoader = ({ loading }) => {
//     return (
//       <Backdrop
//         sx={{
//           color: '#fff',
//           zIndex: (theme) => theme.zIndex.drawer + 1,
//           display: 'flex',
//           flexDirection: 'column',
//         }}
//         open={loading}
//       >
//         <CircularProgress color="inherit" />
//         <Typography
//           variant="h6"
//           sx={{ mt: 2, color: 'white' }}
//         >
//           Loading, please wait...
//         </Typography>
//       </Backdrop>
//     );
//   };
